











































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import * as firebase from 'firebase/app';
import {mapGetters} from "vuex";
import AnnouncementForm from "@/forms/AnnouncementForm.vue";
import {v1 as uuidv1} from 'uuid';
import VueGoogleAutocomplete from "@/components/VueGoogleAutocomplete.vue";
import {EUserType} from "@/types";
import {removeUndefined} from "@/utils";

@Component({
    components: {VueGoogleAutocomplete, AnnouncementForm},
    name: "CompanyForm",
    computed: {
        ...mapGetters({user: 'user', profile: 'profile'})
    }
})
export default class CompanyForm extends Vue {
    @Prop({type: Boolean, default: false}) readonly inlineAnnouncements?: boolean;

    private user?: any;
    private profile?: any;
    private announcements: any[] = [{id: uuidv1()}];
    private company: any = {};
    private save_state: number = 0;

    private defaultValues = {
        nome_ragione_sociale: '',
        p_iva: '',
        indirizzo: '',
        num_telefono: '',
        email: '',
        sito_web: '',
        descrizione: '',
        tipologia: EUserType.Company
    }

    get saveState(){
        return this.save_state;
    }

    private manageSave(invalid:boolean, errors:[]){
        if(invalid){
            //FIXME mi sembra strano che il pacchetto di validazione non permetta un metodo semplice per far riprendere il focus...
            (document.querySelector('input.is-invalid') as HTMLElement).focus()
        } else {
            this.saveCompany();
        }
    }

    set saveState(val: number) {
        if (val == 1) {
            this.save_state = 1;
        }
        if (val == 2) {
            setTimeout(() => {
                this.save_state = 2;
                setTimeout(() => {
                    this.save_state = 0
                }, 2000);
            }, 2000)
        }
        if (val == 3) {
            setTimeout(() => {
                this.save_state = 3;
                setTimeout(() => {
                    this.save_state = 0
                }, 2000);
            }, 2000)
        }
    }

    private created() {

        this.company = {
            ...this.defaultValues, ...{
                num_telefono: this.user.phoneNumber || '',
                email: this.user.email || ''
            }, ...this.profile
        }
    }

    //@ts-ignore
    private getValidationState({dirty, validated, valid = null}) {
        return dirty || validated ? valid : null;
    }

    private saveCompany() {
        let deferreds: any[] = [];

        if (this.inlineAnnouncements) {
            deferreds = (this.$refs['announcements'] as any[]).map((form: AnnouncementForm) => {
                //@ts-ignore
                return form.saveAnnouncement()
            })
        }
        this.saveState = 1;
        Promise.all(deferreds).then(() => {
            firebase.firestore().collection('users').doc(this.user.id).set(removeUndefined(this.company)).then(() => {
                this.$store.dispatch('setProfileRefs');
                this.saveState = 2;
                this.$emit('saved')
            })
        }).catch(() => {
            this.saveState = 3;
        })
    }

    private getUuid() {
        return uuidv1()
    }

    private setAddressData(data: any) {
        this.company = {...this.company, ...data}
    }


}
